'use client'

/**
 * SymbolFeedLink — THE site-wide affordance for a ticker's feed page (owner 2026-07-06):
 * everywhere a symbol appears, the symbol itself links to the chart and this small icon
 * beside it opens /stocks/SYMBOL (alert history + trader talk). One icon, one placement,
 * learn it once. Muted at rest so dense surfaces (alerts, watchlists) stay clean; warms
 * amber on hover. stopPropagation so it composes inside clickable rows/cards.
 * Inside a ?embed=1 iframe it targets _top so the feed never loads inside the frame.
 */

import Link from 'next/link'
import { Newspaper } from 'lucide-react'
import { useEffect, useState } from 'react'

export default function SymbolFeedLink({
  symbol,
  className = '',
  iconClass = 'h-3.5 w-3.5',
}: {
  symbol: string
  className?: string
  iconClass?: string
}) {
  const [inEmbed, setInEmbed] = useState(false)
  useEffect(() => {
    try { setInEmbed(new URLSearchParams(window.location.search).get('embed') === '1') } catch { /* ssr */ }
  }, [])
  const sym = String(symbol || '').toUpperCase()
  if (!sym) return null
  return (
    <Link
      href={`/stocks/${encodeURIComponent(sym)}`}
      target={inEmbed ? '_top' : undefined}
      onClick={(e) => e.stopPropagation()}
      title={`$${sym} feed - alerts & trader talk`}
      aria-label={`${sym} feed`}
      className={`inline-flex flex-shrink-0 items-center rounded p-0.5 text-zinc-600 transition-colors hover:bg-amber-500/15 hover:text-amber-300 ${className}`}
    >
      <Newspaper className={iconClass} />
    </Link>
  )
}
